import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 用户信息
    userInfo: null,
    // 网站配置
    siteConfig: {
      title: '环球留学',
      description: '专业的外国留学服务平台'
    },
    // 导航菜单
    navMenu: [
      { name: '首页', path: '/' },
      { name: '关于我们', path: '/about' },
      { name: '服务项目', path: '/services' },
      { name: '留学国家', path: '/countries' },
      { name: '新闻资讯', path: '/news' },
      { name: '联系我们', path: '/contact' }
    ]
  },
  mutations: {
    // 设置用户信息
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    // 更新网站配置
    UPDATE_SITE_CONFIG(state, config) {
      state.siteConfig = { ...state.siteConfig, ...config }
    }
  },
  actions: {
    // 登录动作
    // eslint-disable-next-line no-unused-vars
    async login({ commit }, loginData) {
      try {
        // 这里可以调用API进行登录
        // const response = await api.login(loginData)
        // commit('SET_USER_INFO', response.data)
        console.log('登录数据:', loginData)
        // 暂时注释掉commit，避免ESLint警告
        // commit('SET_USER_INFO', { id: 1, name: '测试用户' })
      } catch (error) {
        console.error('登录失败:', error)
        throw error
      }
    },
    // 退出登录
    logout({ commit }) {
      commit('SET_USER_INFO', null)
    }
  },
  getters: {
    // 是否已登录
    isLoggedIn: state => !!state.userInfo,
    // 获取用户信息
    getUserInfo: state => state.userInfo,
    // 获取导航菜单
    getNavMenu: state => state.navMenu
  }
}) 